import { bool } from 'prop-types';
import cx from 'classnames';
import * as classNames from './Maintenance.module.css';

const Maintenance = ({ isMobile }) => {
  return (
    <div>
      <div className={classNames.header}>
        <h1
          className={cx(classNames.title, {
            [classNames.mobile]: isMobile,
          })}
        >
          Customizations
        </h1>
        <div
          className={cx(classNames.statusContainer, {
            [classNames.mobile]: isMobile,
          })}
        >
          <div className={classNames.status}>
            Status: Closed
            <div className={classNames.statusLight}>&nbsp;</div>
          </div>
        </div>
      </div>
      <div
        className={cx(classNames.closedMsg, {
          [classNames.mobile]: isMobile,
        })}
      >
        <i
          className={cx(classNames.icon, {
            [classNames.mobile]: isMobile,
          })}
        />
        <h3
          className={cx(classNames.maintenanceHeader, {
            [classNames.mobile]: isMobile,
          })}
        >
          This Section is Currently Down
        </h3>
        <div className={classNames.textContainer}>
          <p className={classNames.maintenanceText}>
            We apologize for any inconvenience caused. We’re working to get this resolved! Please
            check back later.{' '}
          </p>
        </div>
      </div>
    </div>
  );
};

Maintenance.propTypes = {
  isMobile: bool.isRequired,
};

export default Maintenance;
